import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const WarningCircleIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('WarningCircleIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.997 6.127v2.7m0 2.686h.006m6.767.264L9.42 2.525c-.637-1.1-2.201-1.1-2.838 0L1.23 11.778c-.646 1.115.145 2.522 1.418 2.522h10.704c1.273 0 2.064-1.407 1.418-2.523"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
WarningCircleIcon.id = 'WarningCircleIcon';
WarningCircleIcon.displayName = 'WarningCircleIcon';
export default WarningCircleIcon;
